import api from "./api"
import {
  DashboardStats,
  TreeByRegion,
  TreeByType,
  MapPin,
} from "../types"

export const reportService = {

  async getStats(): Promise<DashboardStats> {
    const { data } = await api.get("/reports/stats")
    return data
  },

  async getTreesByRegion(): Promise<TreeByRegion[]> {
    const { data } = await api.get("/reports/trees-by-region")
    return data.data
  },

  async getTreesByType(): Promise<TreeByType[]> {
    const { data } = await api.get("/reports/trees-by-type")
    return data.data
  },

  async getMapPins(params?: {
    region_id?: number
    tree_type_id?: number
  }): Promise<MapPin[]> {
    const { data } = await api.get("/reports/map-pins", { params })
    return data.data
  },
}